// import AIChatButton as A from "./ai/components/AIChatButton";

import React, { lazy, Suspense } from "react";
import AlertModal from "../components/AlertModal/AlertModal";
import useConfig from "../demos/hooks/useConfig";

// Error Boundary component for AIChatButton
class AIChatErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; showModal: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, showModal: false };
  }

  static getDerivedStateFromError(error: Error): {
    hasError: boolean;
    showModal: boolean;
  } {
    // Update state so the next render will show the fallback UI
    return { hasError: true, showModal: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    // Log error to console or error reporting service
    console.error("AIChatButton error:", error, errorInfo);
    // Show modal that AI module is not available
    this.setState({ showModal: true });
  }

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <>
          <div style={{ color: "red", fontSize: "12px" }}>
            AI Chat unavailable
          </div>
          <AlertModal
            isOpen={this.state.showModal}
            onClose={this.handleCloseModal}
            title="AI Module Unavailable"
            description={
              <>
                The AI module is not available. Please contact support to
                acquire a license at{" "}
                <a
                  href="mailto:internationalsales@tailormade.com"
                  className="text-primary-600 hover:text-primary-800 underline"
                >
                  internationalsales@tailormade.com
                </a>
              </>
            }
            closeText="Close"
          />
        </>
      );
    }

    return this.props.children;
  }
}

// Export the AIChatButton component if config.enableAIChat is true or return dummy component
export const AIChatButton = () => {
  const { config } = useConfig();
  if (config.enableAIChat) {
    // lazy loading
    // const importAIChatPath = ;
    // @ts-ignore - Module may or may not exist depending on AI license availability
    const AIChatButton = lazy(
      // @ts-ignore - Dynamic import path that may not exist
      () => import("./ai/components/AIChatButton/AIChatButton")
    );
    return (
      <AIChatErrorBoundary>
        <Suspense fallback={<div>Loading AI Chat...</div>}>
          <AIChatButton />
        </Suspense>
      </AIChatErrorBoundary>
    );
  }
  return <div />;
};
